import { Directive, ElementRef, OnInit, Optional } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { ValidatorService } from './validator.service';

@Directive({
  selector: 'p-autoComplete[appRegisterValidator]',
})
export class RegisterAutoCompleteValidatorDirective implements OnInit {
  constructor(@Optional() private componentRef: AutoComplete, private elementRef: ElementRef, private validatorService: ValidatorService) {
    /** */
  }
  ngOnInit(): void {
    if (this.componentRef != null) {
      this.validatorService.registerAutoComplete(this.elementRef.nativeElement.id, this.componentRef);
    }
  }
}
